package com.cs.ejobin.ui.theme

import androidx.compose.material3.CardColors
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable

object AppSurfaces {
    @Composable
    fun glassCard(): CardColors =
        CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surface.copy(alpha = 0.88f),
            contentColor = MaterialTheme.colorScheme.surface.copy(alpha = 0.88f),
            disabledContentColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.88f),
            disabledContainerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.88f)
        )
}